export const covertToJSON = (data) => JSON.parse(JSON.stringify(data));
